import Form from 'react-bootstrap/Form';
import React, { useState, useEffect, useRef } from "react"
import {useNavigate} from 'react-router-dom';
import Overlay from "react-overlay-component";
import { Vertify } from '@alex_xu/react-slider-vertify';
import PanelInputMobile from '../../../components/panel/PanelInputMobile.js';
import PanelCheckboxTnc from '../../../components/panel/PanelCheckboxTnc.js';
import FailTitleDiv from '../../../components/shared/TitleDiv.js';
import LongButton from '../../../components/shared/LongButton.js';
//import PanelSelectShop from '../../../components/panel/PanelSelectShop.js';
//import PanelSelectProductQty from '../../../components/panel/multi-pickup/PanelSelectProductQtyMulti.js';
import PanelSelectShop from '../../../components/panel/non-payment-registration/PanelSelectShop.js';
import PanelSelectProductQty from '../../../components/panel/non-payment-registration/PanelSelectOnlyOneProduct.js';
import '../../../css/EnrollM1.css';
import Spinner from 'react-bootstrap/Spinner';


function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));

}

function EnrollM1(props) {
    const navigate = useNavigate();
    const PUBLIC_URL =process.env.PUBLIC_URL;
    const url = new URL(window.location.href);
    let baseUrl = `${url.protocol}//${url.host}/`;

    const TastingEventNames = process.env.REACT_APP_TASTING_EVENT_NAME.split(',');

    if (process.env.REACT_APP_API_URL != ""){
      baseUrl = process.env.REACT_APP_API_URL;
    }
    const eventName = window.name;

    const isSessionEvent = () =>{
      if (TastingEventNames.includes(eventName) )
        return true;
      if (eventName === "2026032829_TSTopening")
        return true;
      return false;
    } 

    const bgColor = process.env.REACT_APP_BG_COLOR;
    var clearChildItemsState = null;
    let tracking_channel = "others";

    if(props.isdebugmode) console.log(baseUrl);
    
    //navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
    if (props.channel !== ""){
      tracking_channel = props.channel;
    }
    const geocodes = [
        {id:1, display: '香港(+852)', value: '852', placeHolder: '例子:55667788', maxLength : 8},
        {id:2, display: '內地(+86)', value: '86', placeHolder: '例子:11122223333', maxLength : 11},
        {id:3, display: '澳門(+853)', value: '853', placeHolder: '例子:55667788', maxLength : 8}
    ];
    const [settings, setSettings] = useState({
      Event_Status: "",
      Is_Maintenance: false,
      Event_Picture: "",
      Event_Button_Wording: "",
      Event_PreOrder_Method: "",
      Event_PreOrder_TnC: "",
      AllButton_Color: "",
      AllButton_FontColor: "",
      AllTitle_Color: "#FFFFFF",
      AllTitle_FontColor: "#FFFFFF",
      AllBackground_Color : "#FFFFFF",
      Event_Version: ""
    });  
    
    const [isSubmitting, setSubmitting] = useState(false);
    const [rules, setRules] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [orgItem_Details, setOrgItem_Details]=useState([]);
    const [item_Details, setItem_Details]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [totalAmount, setTotalAmount]=useState(0);
    const [isOpenVerify, setIsOpenVerify] = useState(false);
    const [puzzleUrl, setPuzzleUrl] = useState("");
    const [visible, setVisible] = useState(false);
    const [inputs, setInputs] = useState({
      event_code : "",
      batch_no : "",
      stamp : "",
      code : "",
      geocode : "",
      mobile : "",
      geocode2 : "",
      mobile2 : "",
      loc_code : "",
      channel : tracking_channel,
      tracking_channel : tracking_channel,
      cbxTncs:[]
    });
      const style = {
        margin: '50px'
      };
    useEffect(() => {
        let GetEventStatusURL = baseUrl + "frontend/api/Enroll/GetEventStatus";
        fetch(GetEventStatusURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          setSettings(previousState => {
            return { 
              ...previousState,
              Event_Status : result.Event_Status,
              Is_Maintenance: result.Is_Maintenance,
              Event_Button_Wording : result.Event_Button_Wording.replace("按此 ",""),
              Event_Picture : result.Event_Picture,
              Event_PreOrder_Method : result.Event_PreOrder_Method,
              Event_PreOrder_TnC : result.Event_PreOrder_TnC,
              AllButton_Color : result.AllButton_Color,
              AllButton_FontColor : result.AllButton_FontColor,
              AllTitle_Color : result.AllTitle_Color,
              AllTitle_FontColor : result.AllTitle_FontColor,
              AllBackground_Color : result.AllBackground_Color,
              Event_Version: result.Event_Version
            }
          });

          if (result.Event_Status !== "Processing" && result.Event_Status !== "Testing"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

          // Redirect to enroll page if it is not non-payment event
          if (result.Event_Version != 3){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/enroll');
          }

          //樓上尖沙咀招牌店試食開幕慶典
          if (eventName === "2026032829_TSTopening" && result.Event_Status === "Testing" && props.isExternalAccess === "true")
          {
            navigate('../' + PUBLIC_URL + '/fail-wrong-url');
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });

        
        let GetEventInfoEnrollURL = baseUrl + "frontend/api/Enroll/GetEventInfoEnroll";
        fetch(GetEventInfoEnrollURL, {
          "method": "POST",
          "headers": {
            'Content-Type': 'application/json'
          },
          "body": JSON.stringify({
            "event_Name": eventName
          })
        })
        .then(response => response.json())
        .then(response => { 
          let result = JSON.parse(JSON.stringify(response));
          if(props.isdebugmode) console.log(result);
          ToDataUrl(result.Image_Setting.Puzzle_Picture, function(myBase64) {
            setPuzzleUrl(myBase64); // myBase64 is the base64 string
            setVisible(true);
          });

          setRules(result.EnrollM1_TnC);
          let newcbxTncs=Array();
          for (var i=0;i<result.EnrollM1_TnC.length;i++)
          {
            newcbxTncs.push({TnC_id:result.EnrollM1_TnC[i].TnC_id,
                             checked: result.EnrollM1_TnC[i].IsDefault});
          }
          setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
          let newDistricts= [
            {Loc_Id:'0', Loc_Name: '請選擇',constDisplay_Loc_Id:'',Display_Loc_Name: '',District:'',IsShown:true}]; 
          newDistricts = newDistricts.concat(result.Location_Detail);
          let isRegDateExist=false;
          for (var i=0;i<result.Event_Reg_Period.length;i++)
          {
            let Effective_Date = new Date(result.Event_Reg_Period[i].Effective_Date);
            let DateNow= new Date();
            if (Effective_Date.getFullYear() == DateNow.getFullYear() && Effective_Date.getMonth() == DateNow.getMonth() && Effective_Date.getDate() == DateNow.getDate())
            {
              var Batch_No=result.Event_Reg_Period[i].Batch_No;
              setInputs(oldValues => ({...oldValues, batch_no: Batch_No }));
              isRegDateExist=true;
            }
          }
          if (isRegDateExist)
          {
            setDistricts(newDistricts);
            console.log("result.Item_Detail:"+result.Item_Detail.length);
            setOrgItem_Details(result.Item_Detail);
          }
        })
        .catch(err => { if(props.isdebugmode) console.log(err); });
    }, []);


    const set = name => {
    return ({ target: { value } }) => {
      if (value == null){
        setInputs(oldValues => ({...oldValues, [name]: "" }));
      } else {
        setInputs(oldValues => ({...oldValues, [name]: value }));
      }
    }
  };

  const locationChange = (e) => {
  //const locationChange = async (e) => {
    setInputs(oldValues => ({...oldValues, loc_code: e.target.value }));
    setItem_Details([]);

    let url = "";
    if (eventName === "20250925_movingtruck" || eventName === "2026032829_TSTopening" || eventName === "20260507_korea10")  //same day reg & use
    {
        url = baseUrl + "frontend/api/Enroll/GetAvailableItemByLocation";
    }
    else
    {
        url = baseUrl + "frontend/api/NPEnroll/GetAvailableItemWithinVaildPickupPeriodByLocation";
    }

//console.log(e.target.value);

    if (e.target.value !== "0" )
    {
      setIsLoading(true);
    }
  
    //setIsLoading(true);
    //FOR Testing the loading indicator
     // await timeout(3000);
    
      fetch(url, {
        "method": "POST",
        "headers": {
          'Content-Type': 'application/json'
        },
        "body": JSON.stringify({
          "event_Name": eventName,
          "loc_Id": e.target.value
        })
      })
      .then(response => response.json())
      .then(response => { 
        let result = JSON.parse(JSON.stringify(response));
        if(props.isdebugmode) console.log(result);
        
        //let newItem_Details = [...orgItem_Details]; 
        let newItem_Details = []; 
        for (var i=0;i<result.Items.length;i++)
        {
          if(props.isdebugmode) console.log("i am i");
          for (var j=0;j<orgItem_Details.length;j++)
          {
            if(props.isdebugmode) console.log("i am j");
            if (result.Items[i].Item_Code == orgItem_Details[j].Item_Code) 
            {
              if(props.isdebugmode) console.log("i am j if");
              console.log(result.Items[i].Is_Available);
              newItem_Details.push(orgItem_Details[j]);
              newItem_Details[newItem_Details.length-1].SubTotal = 0;
              newItem_Details[newItem_Details.length-1].Available_PickupDate_From=result.Items[i].Available_PickupDate_From;
              newItem_Details[newItem_Details.length-1].Available_PickupDate_To=result.Items[i].Available_PickupDate_To;
              newItem_Details[newItem_Details.length-1].Is_Available=result.Items[i].Is_Available;
            }
          }
        }
      
        setItem_Details(newItem_Details);
      })
      .catch(err => { console.log(err); })
      .finally(() => {
        setIsLoading(false);
      });

      clearChildItemsState();

  }

  const setItemQty = (Item_Code, value) => {
    let newItem_Details = [...item_Details]; 
    var total=0;
      for (var j=0;j<newItem_Details.length;j++)
      {
        if (Item_Code == newItem_Details[j].Item_Code) 
        {
          newItem_Details[j].SelectedQty=value;
          newItem_Details[j].SubTotal=value*newItem_Details[j].Item_ActualPrice;
        }
        total+=newItem_Details[j].SubTotal;
      }
      setTotalAmount(total);
    setItem_Details(newItem_Details);
  }

  const submitButtonOnClick = (e) => {
    if (isSubmitting) return;

    if (inputs.geocode == "" || inputs.geocode2 == "")
    {
      alert("請選擇區號。");
    }
    else if (inputs.mobile == "" || inputs.mobile2 == "")
    {
      alert("請輸入手提電話號碼。");
    }
    else if (inputs.geocode != inputs.geocode2 || inputs.mobile != inputs.mobile2)
    {
      alert("所輸入的手提電話號碼不相符。請重新輸入。");
    }
    else if (districts.length > 2 && (inputs.loc_code == "" || inputs.loc_code == 0))
    {
      alert("請選擇分店。");
    }
    // else if (inputs.loc_code == "" || inputs.loc_code == 0)
    // {
    //   alert("請選擇分店。");
    // }
    // else if (totalAmount == 0)
    // {
    //   alert("請選擇產品。");
    // }
    else if (item_Details.length == 0)
    {
      if (eventName == "2025_tasting_certificate" || eventName == "2025_tasting_certificate2")
      {
          alert("請選擇試食証場次。");
      }

      if (eventName == "2026032829_TSTopening" )
      {
          alert("請選擇試食証場次。");
      }

      alert("請選擇步驟3。");
    }
    else
    {
      var isSuccess = true;
      
      //special case
      /*for (var i=0;i<item_Details.length;i++)
      {        
        if (item_Details[i].Item_Min_Qty != 0)
        {
          isSuccess=false;
          alert(item_Details[i].Item_Name + "必須選購。");
        }
        if (item_Details[i].SelectedQty > item_Details[i].Item_Max_Qty)
        {
          isSuccess=false;
          alert(item_Details[i].Item_Name + "數量異常。");
        }
      }*/

    if (item_Details.length >= 2)
    {
      //check exceed 1
      const exceedQty = 1;
      var CountQty = 0;

      for (let i = 0; i < item_Details.length; i++) 
      {
        const item = item_Details[i];
        CountQty += parseInt(item.SelectedQty) || 0;
      }
      if (CountQty > exceedQty)
      {
        isSuccess=false;
          if (eventName == "2025062122_carnival")
          {
            alert("只可選擇一個嘉年華入場時段!");
          }
          else if (eventName == "2025_tasting_certificate" || eventName == "2025_tasting_certificate2")
          {
              alert("只可選擇一個使用試食証日子!");
          }

          if (eventName == "2026032829_TSTopening")
          {
            alert("只可選擇一個入場時段!");
          }

        return false;
      }
      else if (CountQty < exceedQty)
      {
        isSuccess=false;
          if (eventName == "2025062122_carnival")
          {
            alert("必須選擇一個嘉年華入場時段!");
          }
          else if (eventName == "2025_tasting_certificate" || eventName == "2025_tasting_certificate2")
          {
              alert("必須選擇一個使用試食証日子!");
          }

          if (eventName == "2026032829_TSTopening")
          {
            alert("只可選擇一個入場時段!");
          }
        
        return false;
      }
    }

    //cbxTnc
    for (var i=0;i<inputs.cbxTncs.length;i++)
    {
      if (!inputs.cbxTncs[i].checked)
      {
        isSuccess=false;
        alert("請同意所有條款。");
      }
    }
    if (isSuccess)
    {
      //console.log(item_Details.length);
      /*for (var i=0;i<item_Details.length;i++)
      {
          console.log(item_Details[i].Item_Code);
      }*/
      //setIsOpenVerify(true);
      setSubmitting(true)
      VertifyonSuccess()
    }
    }
  }

  const VertifyonSuccess = (e) => {
    var Base_url = window.location.protocol + "//" + window.location.host+process.env.PUBLIC_URL+"/"+window.name+"/PaymentResult";
    let url = baseUrl + "frontend/api/NPEnroll/InsertEventRegistration";
    let loc_code = districts.length > 2 ?inputs.loc_code : districts[1].Loc_Id;
    
    let postData ={
      "Event_Name" : eventName,
      "Geocode": inputs.geocode,
      "Mobile": inputs.mobile,
      "Loc_Code": loc_code,  // Default select first location code 
      "Loc_Name" : "",
      "Total_Amount_Mo_Str" : "",
      "Order_Item": {
          "Item_Detail":[
             ]
      },
      "Channel": inputs.channel,
      "Tracking_Channel": inputs.tracking_channel,
      "batch_No": inputs.batch_no,
      "Base_url": Base_url,
      "Is_allow_online_payment": false,
      "Is_allow_offline_payment": false,
      "CreatedBy": "Web"
    };
    //console.log("item_Details.length:" + item_Details.length);
    for (var i=0;i<item_Details.length;i++)
      {
        
        /*if (item_Details[i].SelectedQty > 0)
        {
          let items={"Item_Code": item_Details[i].Item_Code,"Item_Qty": item_Details[i].SelectedQty,"Item_ActualPrice": 0,"Item_TotalPrice": 0}
          postData.Order_Item.Item_Detail.push(items);
        }*/
   
          
       //if (item_Details.length > 2)
       if (item_Details.length > 1)
       {

          if (item_Details[i].SelectedQty > 0)
            {
              let items={"Item_Code": item_Details[i].Item_Code,"Item_Qty": item_Details[i].SelectedQty,"Item_ActualPrice": 0,"Item_TotalPrice": 0}
              postData.Order_Item.Item_Detail.push(items);
            }
        }
        else //DEFAULT ONLY ONE ITEM
        {
          let items = {
            Item_Code: item_Details[i].Item_Code,
            Item_Qty: 1,
            Item_ActualPrice: 0,
            Item_TotalPrice: 0,
          };
          postData.Order_Item.Item_Detail.push(items);

        }

      }


  /*  for (var i=0;i<item_Details.length;i++)
    {
        let items={"Item_Code": item_Details[i].Item_Code,"Item_Qty": 1,"Item_ActualPrice": 0,"Item_TotalPrice": 0}
        postData.Order_Item.Item_Detail.push(items);
    }
*/
//console.log("json: " + JSON.stringify(postData).toString());
    fetch(url, {
      "method": "POST",
      "headers": {
        'Content-Type': 'application/json'
      },
      "body": JSON.stringify(postData)
    })
    .then(response => response.json())
    .then(response => { 
      let result = JSON.parse(JSON.stringify(response));
      //alert(JSON.stringify(response));  
      if(props.isdebugmode) console.log(JSON.stringify(postData));
      if(props.isdebugmode) console.log(JSON.stringify(response));
      if (result.hasOwnProperty('Invoice_Number') && result.hasOwnProperty('hash')){
        navigate('../../../' + PUBLIC_URL + '/' + eventName + '/npsuccess?invoiceno=' + result.Invoice_Number + '&hash=' + result.hash);
      }
        
      if (result.hasOwnProperty('IsSuccess')){
        if(props.isdebugmode) alert(result.ErrorMessage);
        if (result.ErrorCode === 10012){
          navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-duplicate');
        } else if (result.ErrorCode === 10514){
          navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-wrong-format');
        } else if (result.ErrorCode === 10518 || result.ErrorCode === 10005 || result.ErrorCode === 10007){
          if(eventName == "20240914_mid_carnival"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota-carnival-0914');
          } else if (eventName == "20240915_mid_carnival"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota-carnival-0915');
          } else if (eventName == "2025062122_carnival"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota-2025062122_carnival');
          } else if (eventName == "2025_tasting_certificate" || eventName == "2025_tasting_certificate2"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota-tasting_certificate');
          } else if ( eventName == "2026032829_TSTopening"){
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota-2026032829_TSTopening');
          }
          else
          {
            navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-full-quota'); 
          }

        } else {
          navigate('../../../' + PUBLIC_URL + '/' + eventName + '/fail-reg-error?errcode=' + result.ErrorCode);
        }        
      }        
    })
    .catch(err => { console.log(err); setSubmitting(false); });
    
    setIsOpenVerify(false);
  }
  const VertifyonFail = (e) => {

  }
  const VertifyonRefresh = (e) => {

  }
  const checkboxOnChange = (e) => {
    var newcbxTncs=[...inputs.cbxTncs];
    for (var i=0;i<newcbxTncs.length;i++)
    {
      if (("cbxTnc"+newcbxTncs[i].TnC_id) == e.target.name)
      {
        newcbxTncs[i].checked = e.target.checked;
        setInputs(oldValues => ({...oldValues, cbxTncs: newcbxTncs }));
        break;
      }
    }
  }
  const ClearSelectedItems = (childClearSelectedItems) => {
    clearChildItemsState = childClearSelectedItems;
  }

  useEffect(() => {
    //console.log("districts.length:" + districts.length);
     if(districts.length > 0){
        const event = { target: { value: districts.length > 2 ? inputs.loc_code : districts[1].Loc_Id } };
        //locationChange(event);
     }
    
  }, [districts]);

  

  return (
    <>
        <Overlay configs={{animate: true}} isOpen={isOpenVerify} closeOverlay={()=>setIsOpenVerify(false)}>
        <p></p>
        <Vertify
            className={style}
            imgUrl={puzzleUrl}
            text="向右拉箭咀以完成上方拼圖"
            width={320}
            height={180}
            visible={visible}
            onSuccess={() => VertifyonSuccess()}
            onFail={() => VertifyonFail()}
            onRefresh={() => VertifyonRefresh()}
        />
        </Overlay>
        <Form>
          
          {
            isLoading &&  
            <div className="d-flex flex-column Location_Loader">  
              <div class="row">
                  <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                  </div>
              </div>
              <br/>
              <div class="row">
                <strong>加載中，請耐心等待</strong>
              </div>
            </div>
          }

        <FailTitleDiv class="title" title={settings.Event_Button_Wording} bgColor={settings.AllTitle_Color} fontColor={settings.AllTitle_FontColor}></FailTitleDiv>
                <div className="d-grid" style={{backgroundColor: settings.AllBackground_Color}}>
                    <PanelInputMobile geoList={geocodes} setGeocode={set('geocode')} setMobile={set('mobile')} setRepeatGeocode={set('geocode2')} setRepeatMobile={set('mobile2')}></PanelInputMobile>
                    {
                      ////title="登記【樓上二十七周年誌慶嘉年華】入場門券"
                      districts.length >= 2 && 
                      <PanelSelectShop districtsList={districts} onChange={locationChange}></PanelSelectShop>
                    }
                    {
                      //item_Details.length > 2 &&
                      <PanelSelectProductQty eventName={eventName} passClearSelectedItems={ClearSelectedItems} item_Details={item_Details} totalAmount={totalAmount} setItemQty={(Item_Code, value) =>setItemQty(Item_Code, value)} isShowScanInput={false} isSessionEvent={isSessionEvent()}></PanelSelectProductQty>
                  
                    }

                    <PanelCheckboxTnc tncList={rules} checkboxOnChange={checkboxOnChange}></PanelCheckboxTnc>
                    {
                      settings.AllButton_Color !== '' && <LongButton isDisabled={isSubmitting} class="enroll-button" text="繼續" bgColor={settings.AllButton_Color} fontColor={settings.AllButton_FontColor}  onClick={() => { submitButtonOnClick(); }} ></LongButton>
                    }
                </div>
        </Form>
    </>
  );
}

function ToDataUrl(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
          callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.setRequestHeader("Cache-Control", "no-cache");
  xhr.responseType = 'blob';
  xhr.send();
}

export default EnrollM1;
